export const SET_KIOSK_REFERENCE = 'SET_KIOSK_REFERENCE'
export const ADD_KIOSK_LOADING = 'ADD_KIOSK_LOADING'
export const ADD_KIOSK_SUCCESS = 'ADD_KIOSK_SUCCESS'
export const ADD_KIOSK_FAILED = 'ADD_KIOSK_FAILED'
export const LINK_KIOSK_LOADING = 'LINK_KIOSK_LOADING'
export const LINK_KIOSK_SUCCESS = 'LINK_KIOSK_SUCCESS'
export const LINK_KIOSK_FAILED = 'LINK_KIOSK_FAILED'
export const SET_KIOSK = 'SET_KIOSK'